module.exports = __webpack_public_path__ + "static/media/ycmspl.05cdaf8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/ycmspl.png
// module id = 455
// module chunks = 0